export type ProfileFetchErrors = {
    expertises: boolean;
};

export function initFetchErrors(): ProfileFetchErrors {
    return {expertises: false};
}
